import { selectFromExportColumnDto } from '../../models';

export default selectFromExportColumnDto().key.label.group.isCustomField.toString();
